import React, { ReactNode, useCallback, useEffect, useState } from "react";
// import { IoIosNotifications } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import { HeaderContainer } from "./HeaderStyled";
import { CircularAvatarPhoto } from "../../elements/CircularAvatarPhoto";
import { isMobile } from "../../../isMobile";
import { useUserContext } from "../../../context/user/AuthContext";

import { IoIosNotifications } from "react-icons/io";

import NotificationsService from "../../../services/notifications.service.js";
import logoCiaAutismo from "../../../assets/images/logo_cia_autismo.png";
import logoCiaAutismoPlus from "../../../assets/images/logo-cia-novo-roxo.png";
import profilePicPlaceholder from "../../../assets/images/profile_avatar_placeholder.png";
import { AiOutlineGift } from "react-icons/ai";
import { HeaderSearch } from "../../features/SearchBar";

export interface Props {
	background?: "primary" | "default" | undefined;
	children?: ReactNode;
	title: string;
	username: string;
	subTitle?: string;
	logoUrl?: string;
	userImageUrl?: string;
	notificationCount?: number;
	showUserAvatar?: boolean;
	showSchoolLogo?: boolean;
}

const HeaderWrapper: React.FC<Props> = ({ children, ...props }: Props) => {
	const { userData, handleLogout } = useUserContext();
	//console.log("USER DATA FROM HEADER ==> ", userData);
	const navigate = useNavigate();
	const logout = useCallback(() => {
		handleLogout();
		navigate("/");
	}, []);
	const [notificationsCount, setNotificationsCount] = useState(0);

	// Handle search item click - navigate based on content type
	const handleSearchItemClick = useCallback((item: any) => {
		switch (item.tipo) {
			case 'ARTIGO':
				// Navigate to article
				navigate(`/artigo/${item.ref1_slug || item.id}`);
				break;
			case 'CURSO':
				// Navigate to course
				navigate(`/cursos/${item.ref1_slug || item.id}`);
				break;
			case 'AULA':
				// Navigate to specific lesson
				if (item.ref2_slug) {
					navigate(`/cursos/${item.ref2_slug}/${item.id}`);
				} else {
					navigate(`/aulas/${item.id}`);
				}
				break;
			case 'VIDEO':
				// Navigate to video
				if (item.ref2_slug) {
					navigate(`/serie/${item.ref2_slug}/${item.id}`);
				} else {
					navigate(`/videos/${item.id}`);
				}
				break;
			case 'TOPICO':
				// Navigate to topic
				navigate(`/noticias/${item.id}`);
				break;
			default:
		}
	}, [navigate]);
	const getNotificationsCount = useCallback(async () => {
		const notificationsService = new NotificationsService({ unread: true });
		const response = await notificationsService.list();
		//console.log("Notifications Response", response);
		setNotificationsCount(response.count);
	}, [notificationsCount]);

	const isPlus = useCallback(() => {
		const userGroups = userData?.grupos?.split(",") ?? [];
		if (userGroups.includes("Alunos") || userGroups.includes("NMAAlunos")) {
			return true;
		}
		return false;
	}, [userData]);

	useEffect(() => {
		if (!localStorage.getItem("userImg") && userData?.foto) {
			localStorage.setItem("userImg", userData.foto);
		}
		getNotificationsCount();
		//alert(navigator.userAgent);
	}, []);

	return (
		<HeaderContainer {...props} className={isPlus() ? "isPlus" : ""}>
			<div className='schoolInfo'>
				{props.logoUrl && (
					<div className='schoolLogo'>
						<Link to='/'>
							<CircularAvatarPhoto avatarImg={props.logoUrl} avatarName={props.title} borderColor={isPlus() ? '#6C2EED' : 'primary'} borderType='single' innerBorderSize='2px' size={isMobile.any() ? "40px" : "45px"} darken />
						</Link>
					</div>
				)}
				{isMobile.any() ? (
					<h1 className='logoNma'>
						<Link to='/'>{isPlus() ? <img src={logoCiaAutismoPlus} alt='' /> : <img src={logoCiaAutismo} alt='' />}</Link>
					</h1>
				) : (
					<h1 className={props.showSchoolLogo ? "showLogo" : "hideLogo"}>
						{isPlus() ? <>
							<Link to='/'><img style={{ height: '40px' }} src={logoCiaAutismoPlus} alt='CIA Autismo Plus' /></Link>
						</> : <>
							Centro Integrado de Aprendizagem em Autismo
							{isPlus() && <span className='plus'> Aluno Plus</span>}
							<small>Plataforma de ensino oficial da Academia do Autismo</small>
						</>}
						{/* {props.subTitle ? <small>{props.subTitle}</small> : ""} */}
					</h1>
				)}
				{/*  */}
			</div>
			{/* {!isMobile.any() && <>
				<a className="btnIndique" href="http://cursoaba.academiadoautismo.com.br/indicacao/?bl_ref=LMGE4&utm_source=cia-topo" target="blank">
					<AiOutlineGift size={20} />
					Indique e ganhe prêmios!
				</a>
			</>} */}

			{/* Global Search Bar - Always Visible for Better Accessibility */}
			<HeaderSearch
				placeholder="Digite para buscar cursos, artigos, vídeos..."
				size="large"
				showButton={false}
				onItemClick={handleSearchItemClick}
			/>

			<div className='studentInfo'>
				{props.showUserAvatar && (
					<div className='nameLogout'>
						<span className='nomeAluno'>{userData?.nome_aluno}</span>
						<button
							className='logoutButton'
							onClick={() => {
								logout();
							}}>
							Sair
						</button>
					</div>
				)}
				{props.showUserAvatar && (
					<Link to='/meu-perfil'>
						<CircularAvatarPhoto
							avatarImg={
								userData?.foto && userData?.foto !== "#"
									? userData?.foto
									: (localStorage.getItem("userImg") ?? undefined) && localStorage.getItem("userImg") !== "#"
										? localStorage.getItem("userImg") ?? undefined
										: profilePicPlaceholder
							}
							avatarName={userData?.name}
							borderColor='white'
							borderType='single'
							innerBorderSize='2px'
							size={isMobile.any() ? "40px" : "45px"}
						/>
					</Link>
				)}
				<div className='notificationBell'>
					<Link to='/notificacoes'>
						<IoIosNotifications size={20} color='#FFF' />
					</Link>
				</div>
				{notificationsCount && (
					<>
						<span className='notificationCount'>{notificationsCount > 9 ? "9+" : props.notificationCount}</span>
					</>
				)}
			</div>
			{children}
		</HeaderContainer>
	);
};

HeaderWrapper.defaultProps = {
	background: "primary",
	showUserAvatar: true,
	showSchoolLogo: true,
};

export { HeaderWrapper as Header };
